import React, { useState } from "react";
import {
  arrow_right_sec,
  arrow_right_wt,
  close,
  hamburger,
  hamburger_dk,
  logo,
  logo_wt,
} from "assets";

import Button from "./Button";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useHistory } from "react-router-dom"

export const Container = styled.div`
  max-width: 1248px;
  margin: 0 auto;
`;

const Wrapper = styled.div`
.active{
  /* color: var(--grey_1); */
  font-weight: 700;
}

  background-color: ${(props) =>
    props.dark ? "var(--background_1)" : props.color ? props.color : "white"};
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
  .sales {
    color: ${(props) => (props.dark ? "" : "var(--secondary)")};
  }
  .mb {
    display: none;
  }
  /* align-items: center; */
  .logo {
    display: flex;
    span {
      height: 2.4rem;
      width: 4.8rem;
      border-radius: 0.8rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      background-color: var(--secondary);
    }
  }

  .ctn {
    display: flex;
    height: 9.6rem;
    font-weight:450;
    align-items: center;
    color: ${(props) => (props.dark ? "white" : "")};
  }

  .links {
    display: flex;
    /* justify-content: space-between; */
    margin: 0 auto;
    width: 19.3rem;
    &>:first-child{
      margin-right: 2.4rem;
    }
  }
  button {
    margin-left: 1.2rem;
    img {
      width: 1.6rem;
    }
  }
  @media (max-width: 768px) {
    .dsk {
      display: none;
    }

    .mb {
      display: block;
      width: 1.2rem;
      margin-left: auto;

      .hamburger {
        position: relative;
      }

      .mb-link-group {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 19.2rem;
      }
      .mb-btn-group {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 21.6rem;
      }
      .nav-items {
        position: fixed;
        /* height: calc(100vh - 9.6rem); */
        transform: translateX(-100%);
        top: 9.6rem;
        left: 0;
        bottom: 0;
        padding: 2.4rem  0;
        /* margin-top: 4.2rem; */
        /* background-color: var(--background_1); */
        background-color: white;
        color: black;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &.open {
          animation: open 0.3s forwards;
        }
        &.close {
          animation: close 0.3s forwards;
        }

        a {
          height: 4.8rem;
          padding: 1.2rem;
          font-size: 1.8rem;
          margin: 0 2.4rem;
          &.center {
            text-align: center;
            font-size: 1.4rem;
            background-color: var(--background);
            margin: 0;
          }
        }
        button {
          border-radius: 0.8rem;
          height: 5.6rem;
          margin: 0 2.4rem;
          font-size: 1.8rem;
          &.dark {
            background-color: var(--primary);
            color: white;
            /* margin: 0; */
            /* margin-bottom: 0; */
          }
          &.white {
            border: 1px solid var(--secondary);
            /* margin: 0; */
            /* margin-top: 0; */
            color: var(--secondary);
            img {
              margin-left: 1.4rem;
            }
          }
        }
      }
    }
  }

  @keyframes open {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(0);
    }
  }

  @keyframes close {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
`;

export default function Nav({ dark, color }) {
  const [open, setOpen] = useState(false);

  const router = useHistory();

  return (
    <>
      <Wrapper
        style={{ background: open && "white" }}
        dark={dark}
        color={color}
        className="outer-most-container"
      >
        <Container className="ctn">
          <Link to="/">
            <div className="logo ">
              <img src={dark ? (open ? logo : logo_wt) : logo} alt="logo" />
              <span>Beta</span>
            </div>
          </Link>
          <div className="links dsk">
            {/* <NavLink activeClassName="active" to="/home">
              Home
            </NavLink>
            <NavLink activeClassName="active" to="/pricing">
              Pricing
            </NavLink> */}
            {/* <Link to="/">Blog</Link> */}
          </div>

          {/* <Link className="dsk sales" to="/contact">
            Contact Sales
          </Link> */}
          <Button
            className="dsk"
            color={dark ? undefined : "black"}
            bd={dark ? undefined : "var(--body_text)"}
            bg={dark ? "#c1c1c114" : "white"}
            text="Sign in"
            onClick={() => router.push("/sign-in")}
          />
          <Button
            className="dsk"
            bg={dark ? "#c1c1c114" : "var(--primary)"}
            endIcon={arrow_right_wt}
            text="Sign up"
            onClick={() => router.push("/welcome")}
          />

          {/*MOBIL */}

          <div className="mb">
            <img
              src={dark ? (open ? close : hamburger) : hamburger_dk}
              onClick={() => setOpen(!open)}
              alt="hamburger"
              className="hamburger"
            />
            <div className={`nav-items ${open ? "open" : "close"}`}>
              <div className="mb-link-group">
                {/* <NavLink activeClassName="active" to="/home">
                  Home
                </NavLink>
                <NavLink activeClassName="active" to="/pricing">
                  Pricing
                </NavLink> */}
                {/* <Link to="/">Blog</Link> */}
              </div>
              <div className="mb-btn-group">
                <button
                  onClick={() => router.push("/sign-in")}
                  className="dark"
                >
                  Sign in
                </button>
                <button
                  onClick={() => router.push("/sign-up/:accountType")}
                  className="white"
                >
                  <span>Sign up</span>
                  <img src={arrow_right_sec} alt="arrow" />{" "}
                </button>
                {/* <Link to="/contact" className="center">Contact Sales</Link> */}
              </div>
            </div>
          </div>
        </Container>
      </Wrapper>
    </>
  );
}
